export enum PaymentStatus {
  Pending = 'pending',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Refunded = 'refunded',
  Disputed = 'disputed',
  Blocked = 'blocked',
  PartiallyRefunded = 'partially refunded'
}
